<template>
  <div class="ns-topnav-image-overlay-container">
    <img
      class="topnav-image"
      :src="localSrc"
      :alt="alt"
      width="340"
      height="100%"
    />
    <div v-if="localSrc && overlayText" class="image-overlay-text">
      {{ overlayText }}
    </div>
  </div>
</template>

<script>
import { ConfigService } from "@nuskin/ns-util";

import { getFullUrl } from "@nuskin/ns-common-lib";

export default {
  name: "NsTopnavImageOverlay",
  props: {
    /**
     * Image source url
     */
    src: {
      type: String,
      default: ""
    },
    /**
     * alt text of the image for accessibility
     */
    alt: {
      type: String,
      default: "Top Nav Image"
    },
    /**
     * Text for the bottom overlay
     */
    overlayText: {
      type: String,
      default: ""
    }
  },
  data: function() {
    return {
      localSrc: undefined
    };
  },
  watch: {
    src(newVal) {
      this.setSrc(newVal);
    }
  },
  mounted: function() {
    this.setSrc();
  },
  methods: {
    setSrc(src = this.src) {
      const marketConfig = ConfigService.getMarketConfig();
      this.localSrc = getFullUrl(marketConfig.siteUrl, src);
    }
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/_global.mixins";
@use "~@nuskin/ns-core-styles/src/scss/globalVariables";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";
@use "~@nuskin/ns-core-styles/src/scss/colors";

.ns-topnav-image-overlay-container {
  position: relative;
  display: flex;
  width: 340px;
  font-weight: map.get(typographyVariables.$typography, font-weight-regular);
}

.topnav-image {
  object-fit: cover;
}

.image-overlay-text {
  position: absolute;
  bottom: 0;
  padding: 10px 15px;
  width: 100%;
  color: rgb(39, 37, 37);
  background-color: #ffffff;
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
  opacity: 0.85;
  box-sizing: border-box;
}
</style>
